import api from "@/lib/api";

export async function startDiscordConnect(navigate) {
  try {
    const { data } = await api.get("/discord/oauth/url");
    if (data?.url) { window.location.href = data.url; return; }
  } catch { /* fall through */ }
  navigate("/account?tab=discord");
}
